webpackJsonp([158748220838619],{

/***/ 343:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>We started working on Speer almost 2 years ago. It wasn't what it is today.\nSpeer (formerly known as Proposl) is a sales accelration software, that helps you reach out to your customers, without annoying them. </p>","frontmatter":{"tags":["product","business","speer"],"path":"/posts/2018/a-new-beginning","title":"A new beginning","date":"July 12, 2017","isFixedPage":null}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---posts-2018-a-new-beginning-108d90eeb8679b4b090c.js